<script setup lang="ts"></script>

<template>
  <!DOCTYPE html>
  <Html lang="en">
    <Head>
      <Title>Rapid Sequence</Title>
    </Head>
  </Html>

  <Body>
    <Toast />
    <ConfirmDialog></ConfirmDialog>
    <div id="site-wrapper">
      <div id="main" class="flex flex-col font-afacad text-lg">
        <HeaderBlock />
        <div class="p-8 pt-4 flex flex-col flex-auto">
          <div class="flex-auto max-w-screen-[1440px] w-full mx-auto">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </Body>
</template>
